import React from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import articleImg from "../../assets/article7.png"
import ArticleContent from "../../components/sections/blog/ArticleContent";
import { articleContent7 } from "../../constants/data";
import RequestDemo from "../../components/common/RequestDemo";

const ArticleFourth = ({title, description }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-[2.25rem] sm:gap-16 lg:gap-0">
      <HeroReuse
        Title="The Rise of RegTech: What It Means for Traditional Regulatory Compliance Teams"
        Description="RegTech is changing how companies manage regulatory compliance. For teams still relying on spreadsheets, manual tracking, and scattered files, this shift brings real benefits."
        date="21 July 2025"
        imgUrl={articleImg}
        titleClass={'tracking-tight pt-3 md:pt-8'}
      />
      <ArticleContent content={articleContent7} toolsClass="font-bold text-darkGray"/>
      <RequestDemo />
    </div>
  );
};

export default ArticleFourth;
